<footer class="footer">
  <div class="footer-container">
    <!-- First Column -->
    <div class="footer-section footer-left">
      <img src="assets/img/shared/alamat-logo-white.png" alt="Alamat Logo">
      <p class="footer-description">
        ALAMATCH is a Philippine hero-based educational card game that aims to help kids improve in math while being fun for all ages! Join us as we look to the future and learn from our past in this thrilling battle between heroes and monsters. Are you ready to join the fight?
      </p>
    </div>

    <!-- Second Column -->
    <div class="footer-section footer-right">
      <h3 class="contact-title">Contact Us</h3>
      <p class="contact-text">Email us at alamatchftw@gmail.com or message us via our Facebook page</p>
      <div class="social-icons">
        <a href="https://www.facebook.com/AlamatchPH/" target="_blank" class="social-icon">
          <img src="assets/img/home/facebook-icon.png" alt="Facebook">
        </a>
        <a href="https://www.tiktok.com/@alamatch" target="_blank" class="social-icon">
          <img src="assets/img/home/tiktok-icon.png" alt="TikTok">
        </a>
      </div>
    </div>
  </div>

  <!-- White line divider -->
  <div class="footer-divider"></div>

  <!-- Copyright and Privacy -->
  <div class="footer-bottom">
    <p>Copyright © {{currentYear}} Alamatch. All rights Reserved</p>
    <!-- <a (click)="navigateToPrivacyPolicy()" class="privacy-link">Privacy Policy</a> -->
  </div>
</footer>